import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_FORECAST_TRIPS_REQUEST,
    FETCH_FORECAST_TRIPS_SUCCESS,
    FETCH_FORECAST_TRIPS_FAILURE,
    FETCH_FORECAST_ACTIVITIES_REQUEST,
    FETCH_FORECAST_ACTIVITIES_SUCCESS,
    FETCH_FORECAST_ACTIVITIES_FAILURE,
} from '../actions/dataActions';
import {
    FETCH_ACTIVITY_FORECASTS_REQUEST,
    FETCH_ACTIVITY_FORECASTS_SUCCESS,
    FETCH_ACTIVITY_FORECASTS_FAILURE,
    FETCH_ACTIVITY_FORECAST_BY_ID_REQUEST,
    FETCH_ACTIVITY_FORECAST_BY_ID_SUCCESS,
    FETCH_ACTIVITY_FORECAST_BY_ID_FAILURE,
} from '../actions/forecastsActions';
import { getForecastTrips, getForecastActivities, getActivityForecasts, getActivityForecastById } from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

/**
 * Saga pour récupérer les prévisions de séjours (trips)
 */
function* fetchForecastTripsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getForecastTrips, params);
        yield put({ type: FETCH_FORECAST_TRIPS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des prévisions de séjours');
        yield put({ type: FETCH_FORECAST_TRIPS_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer les prévisions d'activités
 */
function* fetchForecastActivitiesSaga() {
    try {
        const data = yield call(getForecastActivities);
        yield put({ type: FETCH_FORECAST_ACTIVITIES_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des prévisions d\'activités');
        yield put({ type: FETCH_FORECAST_ACTIVITIES_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer les prévisions d'activités avec pagination
 */
function* fetchActivityForecastsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getActivityForecasts, params);
        yield put({ type: FETCH_ACTIVITY_FORECASTS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des prévisions d\'activités');
        yield put({ type: FETCH_ACTIVITY_FORECASTS_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer une prévision d'activité par ID
 */
function* fetchActivityForecastByIdSaga(action) {
    try {
        const forecastId = action.payload;
        const data = yield call(getActivityForecastById, forecastId);
        yield put({ type: FETCH_ACTIVITY_FORECAST_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de la prévision d\'activité');
        yield put({ type: FETCH_ACTIVITY_FORECAST_BY_ID_FAILURE, payload: errorMessage });
    }
}

/**
 * Watcher pour les actions de prévisions
 */
export function* watchForecastsRequests() {
    yield takeEvery(FETCH_FORECAST_TRIPS_REQUEST, fetchForecastTripsSaga);
    yield takeEvery(FETCH_FORECAST_ACTIVITIES_REQUEST, fetchForecastActivitiesSaga);
    yield takeEvery(FETCH_ACTIVITY_FORECASTS_REQUEST, fetchActivityForecastsSaga);
    yield takeEvery(FETCH_ACTIVITY_FORECAST_BY_ID_REQUEST, fetchActivityForecastByIdSaga);
}




